export default __webpack_public_path__ + "static/6-1b64936ba179ed6d2c57a27a6262a10d.jpg";